import React from 'react';
import { Link } from 'react-router-dom';

const PlanningThankYouPage = () => {
  return (
    <main className="thank-you-page">
      <section className="thank-you-card">
        <p className="eyebrow">Planning request received</p>

        <h1>Thank you — we received your planning request.</h1>

        <p>
          We’ll review the outing you’re interested in, your team details, and
          your planning needs. Then we’ll follow up by email with next steps.
        </p>

        <div className="thank-you-next">
          <h3>What happens next?</h3>

          <ul>
            <li>We review the specific outing you asked about.</li>
            <li>We look at your group size, timing, budget, and goals.</li>
            <li>You receive planning help and next-step guidance by email.</li>
          </ul>
        </div>

        <p>
          Most requests are reviewed within <strong>1 business day</strong>.
        </p>

        <div className="thank-you-actions">
          <Link to="/" className="button primary">
            Return to Teamward
          </Link>

          <Link to="/" className="button secondary">
            Browse More Experiences
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PlanningThankYouPage;
